import React from 'react';
import SelectedDeviceMap from './map'
// import TopView from '../CommonComponents/topView'
import Toolbar from '@mui/material/Toolbar';
import { FormControl, Paper, Container, Typography, Grid, Button, TextField } from "@mui/material";
import Autocomplete from '@mui/material/Autocomplete';
import { SiteAction } from '../../actions/site';

function SelectedDeviceTrack() {

  const [historyBool, setHistoryBool] = React.useState(false)
  const [siteList, setSiteList] = React.useState([])
  const [siteListOld, setSiteListOld] = React.useState([])
  const [routeListOld, setRouteListOld] = React.useState([])
  const [showRouteList, setShowRouteList] = React.useState([])
  const [routeList, setRouteList] = React.useState([])
  const [siteListForDropDown, setSiteListForDropdown] = React.useState([])


  const [siteValue, setSiteValue] = React.useState([])
  const topViewData = { 'title': 'Live Tracking', 'subTitleFirst': 'Dashboard >', 'subTitleSecond': 'Vehicle Management >', 'subTitleThird': 'Live Tracking', 'buttonIcon': false, "buttonText": ' Add Vendor', 'ButtonClick': '', 'backPath': '/dashboard', 'backPathSecond': '/vehiclelist', 'addButtonPath': '/adduser', 'addButton': '', 'addCancelClick': '', 'addClick': '', 'editButton': '', 'editButtonClick': '', 'updatePermission': ['1'], 'updateButton': '', 'goBackEditClick': '', 'updateClick': '', 'addButtonPermission': false, 'hideBtn': true }
  React.useEffect(() => {
    // setSiteListForDropdown(JSON.parse(localStorage.getItem("data")).sites)

    if (!localStorage.getItem('siteRoute')) {
      // fetchSiteList()
    } else {


      // let siteRoutes =JSON.parse(localStorage.getItem('data')).sites
      // let sitess= siteRoutes.filter((e) => e.parentSiteId == null)
      // console.log(sitess)
      // setSiteList(sitess)
      // setSiteListOld(sitess)
      // routeArrayList(siteRoutes.routeDTOList,sitess)  
      // setRouteListOld(siteRoutes.routeDTOList)
      // setRouteList(siteRoutes.routeDTOList)
    }
  }, []);
  const fetchSiteList = () => {

    SiteAction.fetchSiteRouteSubSite(
      {
        companyId: JSON.parse(localStorage.getItem('data')).companyId,
        showSubSite: false,
        showRoute: true
      }
    ).then((response) => {
      //debugger
      if (response != null) {
        console.log(response)
        let sitess = response.siteDTOList.filter((e) => e.parentSiteId == null)
        console.log(sitess)
        setSiteList(sitess)
        setSiteListOld(sitess)
        routeArrayList(response.routeDTOList, sitess)
        setRouteListOld(response.routeDTOList)
      }
      else {
        setSiteList([])
        setSiteListOld([])

      }
    });
  }


  const routeArrayList = (routeArrays, siteArray) => {
    let routeArray = []
    console.log(routeArrays)
    routeArrays && routeArrays.length > 0 && routeArrays.forEach(element => {

      console.log(element.parentSiteId)

      let routeV1 = []

      element.geofenceDTOList.forEach((element, index) => {

        let routeObj = {
          lat: '',
          lng: ''
        }

        routeObj.lat = element.latitude
        routeObj.lng = element.longitude
        routeV1.push(routeObj)




      });




      let routeObj = { bgColor: element.geofenceColor, DToList: routeV1, source: element.source, destination: element.destination, midPointDTOList: element.midPointDTOList }
      routeArray.push(routeObj)

    });


    console.log(routeArray)

    setShowRouteList(routeArray)
  }


  const searchSite = (val) => {
    let filterRouteArray = []

    setSiteValue(val)
    if (val.length > 0) {
      setSiteList(val)

      val.forEach(ele => {
        finalArrayRoute(filterRouteArray, ele)
      });

    } else {
      routeArrayList(routeListOld, siteListOld)
      setRouteList(routeListOld)
      setSiteList(siteListOld)



    }

  }

  const finalArrayRoute = (filterArray, ele) => {

    routeListOld.forEach(element => {
      if ((ele.id == element.source.id) || ele.id == element.parentSiteId) {
        filterArray.push(element)
      }





    });

    console.log(filterArray)
    setRouteList(filterArray)
    routeArrayList(filterArray, siteListOld)
  }

  const searchRoute = (val) => {

    if (val.length > 0) {
      routeArrayList(val, siteListOld)

    } else {
      routeArrayList(routeList, siteListOld)

    }

  }


  return (
    <div style={{ width: "100%", marginLeft: "2rem" }}>
      <Container style={{maxWidth:"100%"}}>
        {/* <TopView data={topViewData} /> */}
        <Paper>
          <Toolbar style={{ marginLeft: "-8px", marginBottom: '-10px' }}>


          </Toolbar>

          <SelectedDeviceMap history='false' historyBool={historyBool} setHistoryBool={setHistoryBool} showRouteList={showRouteList} siteList={siteList} />
        </Paper>
      </Container>
    </div>
  )
}

export default SelectedDeviceTrack
